const ApiUrl = "https://cms.msscc.in/api";
export default ApiUrl;
